import React, { Component } from 'react';
import FlashMessage from '~/FlashMessage';
import Navigation from '~/UI/Navigation/Navigation';

import styles from './styles.less';

interface Props {
	children: React.ReactNode;
	navigation: React.ReactNode;
	navigationPanel: React.ReactNode;
	bottomNavigationPanel: React.ReactNode;
	hasPanel: boolean;
	spacedOut: boolean;
}

export default class Layout extends Component<Props> {
	static defaultProps = {
		navigation: null,
		navigationPanel: null,
		bottomNavigationPanel: null,
		spacedOut: false,
		hasPanel: false,
	};

	render() {
		const { children, navigation, navigationPanel, bottomNavigationPanel, hasPanel } = this.props;

		return (
			<div className={this.resolveClassName()}>
				<Navigation bottomPanel={hasPanel ? bottomNavigationPanel : null} panel={navigationPanel}>
					{navigation}
				</Navigation>
				{children}
				<FlashMessage />
			</div>
		);
	}

	resolveClassName(): string {
		const { hasPanel, spacedOut, bottomNavigationPanel } = this.props;

		if (hasPanel && spacedOut && bottomNavigationPanel) {
			return styles.spacedOutPageWithPanel;
		}
		if (hasPanel && bottomNavigationPanel) {
			return styles.pageWithPanel;
		}
		if (spacedOut) {
			return styles.spacedOutPage;
		}
		return styles.page;
	}
}
